export const rulesViolated = {
    moneyLaundry: 'Penningtvätt',
    fraud: 'Bedrägeri',
    forgery: 'Förfalskning',
    theft: 'Stöld',
    secondOffence: 'Andra lagöverträdelser',
    dontKnow: 'Vet inte',
};
